import React from 'react';
import { RichText } from 'prismic-reactjs';
import { useStaticQuery } from 'gatsby';
import { DisplayLarge } from './display-large.styled';
var DisplayLargeText = function DisplayLargeText(_ref) {
    var richText = _ref.richText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("2038634511"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(DisplayLarge, {
        color: color,
        customStyles: customStyles,
        configStyles: prismicStylesConfig.data.display_large_text_styles.text
    }, /*#__PURE__*/ React.createElement(RichText, {
        render: richText
    }));
};
export default DisplayLargeText;
